/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CpdEducationMaterialResponseDtoPaginationResponseResponse } from '../models/CpdEducationMaterialResponseDtoPaginationResponseResponse';
import type { CpdFlagDtoResponse } from '../models/CpdFlagDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CpdMaterialService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param patientId
     * @param sedationId
     * @returns CpdFlagDtoResponse Success
     * @throws ApiError
     */
    public getApiCpdMaterialPatientSedationDetailCpdEducationMaterial(
        patientId: string,
        sedationId: string,
    ): CancelablePromise<CpdFlagDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/CpdMaterial/Patient/{patientId}/SedationDetail/{sedationId}/CpdEducationMaterial',
            path: {
                'patientId': patientId,
                'sedationId': sedationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param pageNo
     * @param pageSize
     * @returns CpdEducationMaterialResponseDtoPaginationResponseResponse Success
     * @throws ApiError
     */
    public getApiCpdMaterialCpdEducationMaterials(
        pageNo?: number,
        pageSize?: number,
    ): CancelablePromise<CpdEducationMaterialResponseDtoPaginationResponseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/CpdMaterial/CpdEducationMaterials',
            query: {
                'PageNo': pageNo,
                'PageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
